import { render, staticRenderFns } from "./Thumb.vue?vue&type=template&id=282ee25b&scoped=true"
import script from "./Thumb.vue?vue&type=script&lang=ts"
export * from "./Thumb.vue?vue&type=script&lang=ts"
import style0 from "./Thumb.vue?vue&type=style&index=0&id=282ee25b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ee25b",
  null
  
)

export default component.exports